import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation BulkUpdateSpaceRecordFunctionalUsage(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordIds: [ID!]!
    $update: SpaceRecordFunctionalUsageUpdate!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                bulkUpdateSpaceRecordFunctionalUsage(
                  spaceRecordIds: $spaceRecordIds
                  update: $update
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.BulkUpdateSpaceRecordFunctionalUsageMutation,
  undefined,
  graphql.schema.BulkUpdateSpaceRecordFunctionalUsageMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
